import { IGetState, TCardId } from 'app/types/types';
import { Dispatch, ThunkAction } from 'app/types/actions';
import { uploadFiles } from '../effects/uploadFiles';
import { SegmentCardPasteFileTarget } from 'app/middlewares/segment/trackEntities/cardEvents';
import { attachmentPasteErrorSegmentEvent, attachmentPastedSegmentEvent } from '../../../CardAttachmentsSectionHOC/effects/segmentEffects';

export const onPasteFile = (
    cardId: TCardId,
    files: File[],
    onProgress: (percent: number) => void
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (!files) {
            return dispatch(attachmentPasteErrorSegmentEvent(SegmentCardPasteFileTarget.CARD));
        }

        dispatch(attachmentPastedSegmentEvent(SegmentCardPasteFileTarget.CARD));
        return dispatch(uploadFiles(cardId, files, onProgress, true));
    };
    return action;
};
